import e from "./index888.js";
import u from "./index795.js";
function l(r, s, t) {
  var a = s(r);
  return u(r) ? a : e(a, t(r));
}
export {
  l as default
};
